import { useState } from "react";

export const useDebounce = (callback, delay) => {
    const [timeoutId, setTimeoutId] = useState(null);

    return (...args) => {
        clearTimeout(timeoutId);
        const id = setTimeout(() => {
            callback(...args);
        }, delay);
        setTimeoutId(id);
    };
};